module.exports = __webpack_public_path__ + "static/media/x_logo_white.0c9462a7.svg";